import { jsx } from "panel";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import {
  FormattedPropertyLayout,
  FormattedPropertyMixin
} from "common/widgets/profile-activity/formatted-property/template";
import { EventPropertyToggleChoices } from "./types";
export function template() {
  const { selectedToggle } = this.state;
  const { allProperties, userDefinedProperties, mixpanelProperties } = this.helpers.splitPropertiesForEvent();
  const ShowProperties = ({ properties }) => /* @__PURE__ */ jsx("div", {
    sel: ".event-properties"
  }, properties.map((property) => /* @__PURE__ */ jsx("div", {
    sel: ".property-row"
  }, /* @__PURE__ */ jsx(FormattedPropertyMixin, {
    property,
    layout: FormattedPropertyLayout.Horizontal
  }))));
  return /* @__PURE__ */ jsx("div", {
    sel: ".single-event-properties"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".event-properties-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".properties-title"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      theme: ToggleTheme.SegmentedController,
      selected: selectedToggle,
      options: this.helpers.propertiesToggleOptions({
        allPropertiesLength: allProperties.length,
        userDefinedPropertiesLength: userDefinedProperties.length,
        mixpanelLength: mixpanelProperties.length
      })
    },
    on: {
      select: this.helpers.onToggleChange
    }
  })), /* @__PURE__ */ jsx(ShowProperties, {
    properties: selectedToggle === EventPropertyToggleChoices.ALL_EVENT_PROPERTIES ? allProperties : selectedToggle === EventPropertyToggleChoices.USER_DEFINED_EVENT_PROPERTIES ? userDefinedProperties : mixpanelProperties
  })));
}
